"use client";

import { ProjectProps } from "@/types/project/project.type";
import Image from "next/image";

import { TransitionLink } from "../shared/TransitionLink";
import { useLocale } from "@/components/providers/LocaleProvider";
import { pickProjectLocale } from "@/libs/project.libs";

interface ProjectsProps {
  projects: ProjectProps[];
}

const ProjectsGrid: React.FC<ProjectsProps> = ({ projects }) => {
  const { locale } = useLocale();
  return (
    <section className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-12 gap-y-16">
      {projects.map((project) => {
        const copy = pickProjectLocale(project, locale);
        return (
          <TransitionLink
            href={`/projects/${project?.endpoint}`}
            className=" space-y-6"
            key={project.id}
          >
            <div className="relative h-[200px] lg:h-[250px] 2xl:h-[300px] w-full rounded-xl overflow-hidden transition-all duration-300">
              <Image
                src={project.images.mockup[0]}
                alt={copy.title}
                fill
                className="object-cover object-center hover:scale-105 transition-transform duration-300"
                sizes="(min-width: 2200px) 582px, (min-width: 1540px) calc(20.63vw + 132px), (min-width: 1280px) calc(20.42vw + 114px), (min-width: 780px) calc(45vw - 24px), (min-width: 520px) 90vw, calc(8vw + 410px)"
                placeholder="blur"
                blurDataURL="/assets/blur/blur-image.jpg"
              />
            </div>
            <article className=" space-y-[2px]">
              <p className="card-title">
                <strong>{copy.title}</strong>
              </p>
              <p className="card-description">{copy.shortDescription}</p>
            </article>
          </TransitionLink>
        );
      })}
    </section>
  );
};

export default ProjectsGrid;
